import {
  Box
} from '@mui/material';

import { SpinnerIcon } from './Spinner'

export const Spinner = () => <Box 
  sx={{
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexWrap: 'wrap',
  }}
>
  <SpinnerIcon />
</Box>